<template>
  <div id="contenedor-entes-fiscalizadores-main">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'EntesFiscalizadoresMain',
  data() {
    return {};
  },

};
</script>

<style lang="scss">

</style>
